import React from 'react';

import { isNotNil } from 'es-toolkit';
import { isEmpty } from 'es-toolkit/compat';

import type { Nullable } from '@clearverify/types';

import { EmployersTableListQueryVariables, EmployerWhere } from 'src/api';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import {
  prepareEmployerSearchFilterByCategories,
  prepareEmployersFilterByStatus,
} from 'src/utils/employer';
import { gql } from 'src/utils/gql';

export const useEmployersUnderPeoListQueryVariables = (peoId?: Nullable<string>) => {
  const searchQueryVariables = useSearchQueryVariables(prepareEmployerSearchFilterByCategories);

  const { sortQueryVariable, filter, paginationQueryVariables } = useFilterStorage();

  const queryFilter = React.useMemo((): EmployerWhere => {
    const peoFilter: EmployerWhere = {
      peoId: { equals: peoId },
    };

    return gql.wrapToAND(
      [peoFilter, searchQueryVariables, prepareEmployersFilterByStatus(filter)]
        .filter(isNotNil)
        .filter(item => !isEmpty(item)),
    );
  }, [peoId, searchQueryVariables, filter]);

  const variables = React.useMemo((): EmployersTableListQueryVariables => {
    return {
      filter: queryFilter,
      orderBy: sortQueryVariable,
      ...paginationQueryVariables,
    };
  }, [paginationQueryVariables, queryFilter, sortQueryVariable]);

  return variables;
};
